import React from 'react';
import gql from 'graphql-tag';
import { Modal, Form, Transfer, Row, Col, Button } from 'antd';
import { graphql } from '@apollo/client/react/hoc';
import { IMG } from '../../../../config';
import Loading from '../Loading';
import { getIntFromString } from '../functions';

export const LIST_USERS_FOR_ORG_BY_ORGID_QUERY = gql`
  query listUsersForOrgByOrgId(
    $orgId: ID!
    $before: String
    $after: String
    $first: Int
    $last: Int
    $employee_Isnull: Boolean
  ) {
    listUsersForOrgByOrgId(
      orgId: $orgId
      before: $before
      after: $after
      first: $first
      last: $last
      employee_Isnull: $employee_Isnull
    ) {
      edges {
        node {
          id
          username
          firstName
          lastName
          email
          dateJoined
          employee {
            id
          }
        }
      }
    }
  }
`;

const EmployeeTransfer = props => {
  const { listUsersForOrgByOrgId, initialValues, handleSubmit } = props;
  const { ...rest } = props;
  const FormItem = Form.Item;
  const [mockData, setmockData] = React.useState([]);
  const [targetKeys, setTargetKeys] = React.useState([]);
  const [visible, setVisible] = React.useState(false);
  React.useEffect(() => {
    const targetKeys = [];
    // const mockData = [];
    // for (let i = 0; i < 20; i++) {
    //   const data = {
    //     key: i.toString(),
    //     title: `content${i + 1}`,
    //     description: `description of content${i + 1}`,
    //     chosen: Math.random() * 2 > 1,
    //   };
    // if (data.chosen) {
    //   targetKeys.push(data.key);
    // }
    // mockData.push(data);
    // }
    const mockData =
      listUsersForOrgByOrgId &&
      listUsersForOrgByOrgId.edges.map(({ node }) => ({
        title: node.firstName && node.lastName ? `${node.firstName} ${node.lastName}` : node.username,
        key: node.employee && node.employee.id && getIntFromString(node.employee.id)
      }));

    initialValues &&
      initialValues.edgeCount > 0 &&
      initialValues.edges.map(({ node }) => {
        targetKeys.push(getIntFromString(node.id));
      });
    setmockData(mockData);
    setTargetKeys(targetKeys);
  }, [listUsersForOrgByOrgId, initialValues]);

  const filterOption = (inputValue, option) => option.title.indexOf(inputValue) > -1;

  const handleChange = targetkeys => {
    setTargetKeys(targetkeys);
  };

  return (
    <>
      <Button type="primary" ghost onClick={() => setVisible(true)}>
        Add Employee
      </Button>
      <Modal
        destroyOnClose
        visible={visible}
        onCancel={() => setVisible(false)}
        footer={null}
        title="Employee"
        width="45%"
        bodyStyle={{ padding: 12 }}
      >
        <div>
          <Row>
            <Col span={24}>
              {listUsersForOrgByOrgId ? (
                <FormItem labelCol={{ span: 24 }} wrapperCol={{ span: 24, offset: 1 }} {...rest}>
                  <Transfer
                    listStyle={{ height: '50vh', width: '18vw' }}
                    dataSource={mockData}
                    showSearch
                    filterOption={filterOption}
                    targetKeys={targetKeys}
                    onChange={handleChange}
                    // onSearch={handleSearch}
                    render={item => (
                      <>
                        <Row
                          style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                        >
                          <img src={IMG} alt="" style={{ width: 30, borderRadius: 30, marginRight: 10 }} />
                          {item.title}
                        </Row>
                      </>
                    )}
                  />
                </FormItem>
              ) : (
                <Loading size="small" />
              )}
            </Col>
          </Row>
          <Row justify="end">
            <Button
              type="primary"
              onClick={async () => {
                await handleSubmit(targetKeys);
                setVisible(false);
              }}
            >
              Save
            </Button>
          </Row>
        </div>
      </Modal>
    </>
  );
};

export default graphql(LIST_USERS_FOR_ORG_BY_ORGID_QUERY, {
  options: props => {
    return {
      variables: {
        orgId: props.orgId,
        employee_Isnull: false
      },
      fetchPolicy: 'network-only'
    };
  },
  props({ data: { loading, error, listUsersForOrgByOrgId, subscribeToMore, updateQuery } }) {
    return { loading, error, listUsersForOrgByOrgId, subscribeToMore, updateQuery };
  }
})(EmployeeTransfer);
